import { Splide } from '@hh/global.js'

class SectionAboutBlocks extends HTMLElement {
  connectedCallback() {
    this.eventsToRemove = []
    this.aboutSlides = [...this.querySelectorAll('[data-about-slide]')]

    this.initSlider()
    this.initHoverEffect()
  }

  disconnectedCallback() {
    this.slider?.destroy()
    this.eventsToRemove.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler)
    })
  }

  initSlider() {
    this.sliderElm = this.querySelector('[data-about-blocks-slider]')
    if (!this.sliderElm) { return }

    this.slider = new Splide(this.sliderElm, {
      arrows: true,
      pagination: false,
    }).mount()

    const prevButton = this.querySelector('[data-prev-button]')
    const nextButton = this.querySelector('[data-next-button]')
    this.sliderElm.prepend(prevButton ?? '')
    this.sliderElm.append(nextButton ?? '')

    this.updateActiveSlideStyles()
    this.slider.on('move', this.updateActiveSlideStyles.bind(this));
  }

  updateActiveSlideStyles() {
    const activeIndex = this.slider.index;
    const activeSlideElm = this.querySelector(`[data-about-slide="${activeIndex}"]`)
    if (!activeSlideElm) { return }

    const mobileColorTheme = activeSlideElm.dataset.setColorTheme ?? 'dark'
    const mobileBackgroundBlur = activeSlideElm.dataset.setBackgroundBlur ?? 'true'

    const allSlides = this.querySelectorAll('[data-about-slide]')
    allSlides.forEach(slide => {
      slide.setAttribute('data-mobile-color-theme', mobileColorTheme);
      slide.setAttribute('data-mobile-background-blur', mobileBackgroundBlur);
    })

    const mobileMediaItems = this.querySelectorAll('[data-mobile-media]')
    mobileMediaItems.forEach((item, index) => {
      item.classList.toggle('active', index === activeIndex)
    })
  }

  hoverEffectevets(slide) {
    const nonHoveredSlide = this.aboutSlides.find(s => s !== slide)
    if (!nonHoveredSlide) { return }

    this.addTrackedEvent(
      slide,
      'mouseenter',
      () => nonHoveredSlide.classList.add('overlay-active')
    )

    this.addTrackedEvent(
      slide,
      'mouseleave',
      () => nonHoveredSlide.classList.remove('overlay-active')
    )
  }

  initHoverEffect() {
    if (!this.hasAttribute('data-hover-effect-enabled')) { return }
    this.aboutSlides.forEach(slide => {
      this.hoverEffectevets(slide)
    })
  }

  addTrackedEvent(element, event, handler) {
    element.addEventListener(event, handler)
    this.eventsToRemove.push({
      element,
      event,
      handler
    })
  }
}

if (customElements.get('section-about-blocks') === undefined) {
  customElements.define('section-about-blocks', SectionAboutBlocks)
}
